/**
 * @generated SignedSource<<838de5c59d723f0a6aef34b8517a1126>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersRecruitStatusChoices = "F" | "NS" | "P" | "S" | "%future added value";
export type PauseRecruitInput = {
  clientMutationId?: string | null;
  recruitId: string;
};
export type RecruitTitle_pauseRecruit_Mutation$variables = {
  input: PauseRecruitInput;
};
export type RecruitTitle_pauseRecruit_Mutation$data = {
  readonly pauseRecruit: {
    readonly recruit: {
      readonly id: string;
      readonly status: ScreenersRecruitStatusChoices;
    } | null;
  } | null;
};
export type RecruitTitle_pauseRecruit_Mutation = {
  response: RecruitTitle_pauseRecruit_Mutation$data;
  variables: RecruitTitle_pauseRecruit_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PauseRecruitPayload",
    "kind": "LinkedField",
    "name": "pauseRecruit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitNode",
        "kind": "LinkedField",
        "name": "recruit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitTitle_pauseRecruit_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitTitle_pauseRecruit_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "532599e960cb59c0eede09f413476fa0",
    "id": null,
    "metadata": {},
    "name": "RecruitTitle_pauseRecruit_Mutation",
    "operationKind": "mutation",
    "text": "mutation RecruitTitle_pauseRecruit_Mutation(\n  $input: PauseRecruitInput!\n) {\n  pauseRecruit(input: $input) {\n    recruit {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3be2cf2f00c449125d5f1d203407f83";

export default node;
